import { render, staticRenderFns } from "./stepsBank.vue?vue&type=template&id=d395c1de&scoped=true&"
import script from "./stepsBank.vue?vue&type=script&lang=ts&"
export * from "./stepsBank.vue?vue&type=script&lang=ts&"
import style0 from "./stepsBank.vue?vue&type=style&index=0&id=d395c1de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d395c1de",
  null
  
)

export default component.exports